<template>
  <div class="row">
    <header-servico
      tipo="Acompanhamentos"
      :loading="loading"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando acompanhamentos da Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="acompanhamento" />

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <load
                  mode="table"
                  message="Estamos buscando os acompanhamentos."
                  v-if="loadingAcompanhamentos"
                />
                <div
                  v-if="
                    !novo_acompanhamento && !showImpressaoAcompanhamentos
                  "
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button class="btn btn-primary" @click="verificar">
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div class="d-flex align-items-center justify-content-space-between">
                          <div class="input-group mb-3">
                            <b-input
                              :placeholder="$t('Type to search')"
                              class="form-control search-input"
                              type="text"
                              v-model="search"
                              v-on:change="getAcompanhamentos"
                              aria-describedby="input-search"
                            />
                            <div class="input-group-append" role="button">
                              <span class="input-group-text" id="input-search"
                                ><i class="fas fa-search search-icon"
                              /></span>
                              <b-button variant="outline-dark" @click="print()">
                                <i class="fas fa-print"></i>
                              </b-button>
                              <b-button
                                variant="outline-dark"
                                @click="exportar()"
                                :title="$t('Exportar')"
                                v-b-tooltip.hover
                              >
                                <i class="fas fa-file-excel"></i>
                              </b-button>
                            </div>
                          </div>
                          <button class="btn btn-success btn-sm ml-4" @click="gerarImpressao()">
                            Gerar Impressão
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <print-content>
                      <b-table
                        :fields="[
                          {
                            key: 'protocolo',
                            label: $t('Detalhes'),
                          },
                          {
                            key: 'data_ingresso',
                            label: $t('Período'),
                          },
                          {
                            key: 'data_avaliacao',
                            label: $t('Avaliação'),
                          },
                          {
                            key: 'status_nome',
                            label: $t('Status'),
                          },
                          {
                            key: 'actions',
                            label: '',
                            class: 'text-right',
                            thStyle: {
                              width: '95px',
                              minWidth: '95px',
                            },
                          },
                        ]"
                        :items="AcompanhamentosList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="md"
                        table-class="mb-3"
                      >
                        <template v-slot:cell(protocolo)="data">
                          Serviço:
                          <b>{{ data.item.servico }}</b>
                          <br />
                          Protocolo:
                          <b>{{ data.item.protocolo }}</b>
                          <br />
                          Técnico responsável:
                          <b>{{ data.item.responsavel_name }}</b>
                          <br />
                          Técnico autor:
                          <b>{{ data.item.autor }}</b>
                          <br />
                          <i
                            class="mdi mdi-lock mdi-18px text-danger"
                            v-if="data.item.privado == 1"
                            v-b-popover.hover.top="'Acompanhamento com sigilo'"
                          ></i>
                        </template>
                        <template v-slot:cell(data_ingresso)="data">
                          {{ data.item.dataIngresso }}
                          à {{ data.item.dataFinal }}
                        </template>
                        <template v-slot:cell(data_avaliacao)="data">
                          {{ data.item.dataAvaliacao }}
                        </template>
                        <template v-slot:cell(status_nome)="data">
                          <span
                            class="small"
                            v-html="data.item.status_nome"
                          ></span>
                        </template>
                        <template v-slot:cell()="data">
                          <button
                            v-if="data.item.canEdit"
                            @click="redirectAcompanhamento(data.item.id)"
                            class="px-2 mb-0 btn btn-sm btn-success"
                          >
                            <i class="mdi mdi-square-edit-outline" />
                          </button>
                          <BotaoVisualizar
                            v-if="data.item.canView"
                            :to="`/dashboard/acompanhamento/show/${data.item.id}`"
                          />
                        </template>
                        <template v-slot:empty="scope">
                          <div class="text-center my-5">
                            <img
                              :alt="$t('No results')"
                              class="mb-5"
                              src="/img/icons/robot.svg"
                              style="max-height: 165px"
                            />
                            <h3 class="bold">
                              {{ $t("No records found") }}
                            </h3>
                          </div>
                        </template>
                      </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getAcompanhamentos"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoAcompanhamento
                  v-else-if="novo_acompanhamento && !showImpressaoAcompanhamentos"
                  :familia="familia"
                  @voltar="novo_acompanhamento = false"
                />
                <ImpressaoPAF
                  v-else-if="showImpressaoAcompanhamentos && !novo_acompanhamento"
                  @voltar="showImpressaoAcompanhamentos = false"

                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BotaoVisualizar from "../../../../../resources/js/dashboard/components/widgets/BotaoVisualizar.vue";
import NovoAcompanhamento from "./Add";
import ImpressaoPAF from "./ImpressaoPAFs.vue";
export default {
  components: { NovoAcompanhamento, BotaoVisualizar, ImpressaoPAF },
  name: "Acompanhamentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Acompanhamentos"),
    };
  },
  data() {
    return {
      familia: {},
      novo_acompanhamento: false,
      showImpressaoAcompanhamentos: false,
      TipoAcompanhamentosList: [],
      AcompanhamentosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingAcompanhamentos: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      unidade_id: null,
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getAcompanhamentos();
  },
  methods: {
    getAcompanhamentos() {
      this.loadingAcompanhamentos = true;
      axios
        .get("api/dashboard/acompanhamentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.AcompanhamentosList = response.data.data;
          this.pagination = response.data.pagination;
          this.unidade_id = this.$store.state.user.tecnico.unidade_id;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAcompanhamentos();
          } else {
            this.loadingAcompanhamentos = false;
          }
        })
        .catch(() => {
          this.loadingAcompanhamentos = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo da quantidade de registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/acompanhamentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    verificar() {
      let result = 0;

      //verificar se técnico é de uma unidade diferente das que já possui pafs
      let verificar = this.AcompanhamentosList.filter((item) => {

        return (
          item.unidade.id == this.$store.state.user.unidade.id &&
          item.unidade.tipo_id == this.$store.state.user.unidade.tipo_id
        );
      });
      
      if (verificar.length > 0) {
        //Verificar se existe algum acompanhamento em aberto ou em andamento da mesma unidade
        result = this.AcompanhamentosList.filter((item) => {
          if (item.unidade.id == this.$store.state.user.unidade.id) {
            if (item.status_nome.includes("ABERTO")) {
              return true;
            }
            if (item.status_nome.includes("EM ANDAMENTO")) {
              return true;
            }
          }
        });
      }

      this.novo_acompanhamento = true;
      
      //console.log(result.length);

      /*

      if (result.length > 0) {
        swal.fire({
          title: "Aviso!",
          text: "A familia já possui um acompanhamento em ABERTO/EM ANDAMENTO. É preciso finalizar para abrir um novo.",
          icon: "warning",
        });
      } else {
        this.novo_acompanhamento = true;
      }

      */

    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAcompanhamentos();
      }
    },
    redirectAcompanhamento(id) {
      this.$router.push({
        path: `/dashboard/acompanhamento/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    showAcompanhamento(id) {
      this.$router.push({
        path: `/dashboard/acompanhamento/show/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    gerarImpressao() {
      this.showImpressaoAcompanhamentos = true;
    }
  },
};
</script>
